import { Accordion, AccordionButton, AccordionItem, AccordionPanel } from '@reach/accordion';
import React, { useState } from 'react';
import Chat from '../../Chat/Chat';
import ExpandCollapseIcon from '../../../images/back-arrow-blue.png';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { Project } from '../../../types/Project';
import { UserType, UserTypeEnum } from '../../../types/enums/UserTypesEnum';
import { CaptionModeEnum } from '../../../types/enums/CaptionModeEnum';
import useProject from '../../../hooks/useProject';
import { Messages } from '../../../types/Message';

type ProjectUserControlPanelProps = {
  token: string;
  chatMessages: Messages;
  sendMessageToRoomCallback: (messageToSend: string) => void;
  isChatConnected: boolean;
  userType: UserType;
  sendProjectToAllUsers?: (project: Project) => void;
};

const ProjectUserControlPanel = ({
  token,
  sendMessageToRoomCallback,
  chatMessages,
  isChatConnected,
  userType,
  sendProjectToAllUsers,
}: ProjectUserControlPanelProps) => {
  const { t } = useTranslation();
  const { project } = useProject();
  const [captionMode, setCaptionMode] = useState(project.encoder.captionMode);

  const updateStreamTextEventInProject = () => {
    const newProject = _.cloneDeep(project) as Project;

    setCaptionMode(project?.encoder?.captionMode);

    if (newProject.encoder.captionMode > 0) {
      newProject.encoder.captionMode = CaptionModeEnum.None;
    } else {
      newProject.encoder.captionMode = captionMode;
    }

    sendProjectToAllUsers && sendProjectToAllUsers(newProject);
  };

  return (
    <Accordion className="control-panel-accordion" collapsible={true} defaultIndex={1}>
      {userType === UserTypeEnum.Captioner && (
        <AccordionItem>
          <h3>
            <AccordionButton className="control-panel-accordion-button">
              <span className="control-panel-accordion-title-padding">
                {t('producer.control-panel.captioning.heading')}
              </span>
            </AccordionButton>
            <div className="control-panel-accordion-button-on-off">
              <button
                className="control-panel-accordion-button-toggle-button"
                onClick={(event) => {
                  event.stopPropagation();
                  updateStreamTextEventInProject();
                }}
              >
                <span className="control-panel-accordion-button-on-off-button-back"></span>
                {project?.encoder && project?.encoder.captionMode !== CaptionModeEnum.None ? (
                  <>
                    <span className="control-panel-accordion-button-on-off-text">
                      {t('labels.on')}
                    </span>
                    <span className="control-panel-accordion-button-on-off-button-switch"></span>
                  </>
                ) : (
                  <>
                    <span className="control-panel-accordion-button-on-off-text">
                      {t('labels.off')}
                    </span>
                    <span className="control-panel-accordion-button-on-off-button-switch control-panel-accordion-button-on-off-button-switch-off"></span>{' '}
                  </>
                )}
              </button>
            </div>
          </h3>
        </AccordionItem>
      )}
      <AccordionItem>
        <h3>
          <AccordionButton className="control-panel-accordion-button">
            <img
              src={ExpandCollapseIcon}
              alt="open icon"
              className="control-panel-accordion-button-arrow"
            />
            {t('producer.control-panel.chat.heading')}
          </AccordionButton>
        </h3>
        <AccordionPanel className="control-panel-accordion-panel">
          <Chat
            chatMessages={chatMessages}
            userId={token}
            sendMessageToRoomCallback={sendMessageToRoomCallback}
            isChatConnected={isChatConnected}
          />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default ProjectUserControlPanel;
